import Menu from 'assets/images/home/Menu.svg'
import { useDispatch } from 'react-redux'
import { toggleSideBar } from 'store/redux/sidebar'
interface IHeaderProps {
    title: string
}
export default function Header({ title }: IHeaderProps) {
    const dispatch = useDispatch()
    return (
        <>
            <div className=" bg-header-bg w-full px-4 py-3 flex justify-between sticky top-0 z-10 shadow-[0px 2px 4px 0px #0000001A]">
                <div className="flex">
                    <img
                        src={Menu}
                        className=" cursor-pointer"
                        alt="logo"
                        onClick={() =>
                            dispatch(toggleSideBar({ isOpen: true }))
                        }
                    />
                </div>
                <p className=" text-green-1 text-2xl font-black">{title}</p>
                <p></p>
            </div>
        </>
    )
}
